var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { cssClassMap } from '../../../constants/SportCssMap';
import { defineMessages, injectIntl } from 'react-intl';
import Match from '../common/sportsGrid/HighlightedLiveMatch';
import * as DisplayMode from '../../../constants/DisplayMode';
import { winWithoutDraw } from '../common/sportsGrid/matchType';
var messages = defineMessages({
    grid_w1: {
        id: 'grid.w1',
        defaultMessage: 'П1'
    },
    grid_x: {
        id: 'grid.x',
        defaultMessage: 'X'
    },
    grid_w2: {
        id: 'grid.w2',
        defaultMessage: 'П2'
    },
});
var PopularLiveSports = function (props) {
    if (props.matches.size === 0) {
        return false;
    }
    var hideSection = props.matches.size < 2 && props.matches.first().get('outcomesCount') === 0;
    if (hideSection) {
        return false;
    }
    var liveSportClick = function (id) {
        var type = id === 'all' ? DisplayMode.ALL : DisplayMode.SPORT;
        props.setDisplayModeAction({ type: type, id: id });
        props.push('/live');
    };
    var cls = winWithoutDraw.find(function (m) { return m === props.sportId; }) ? ' win-without-draw' : '';
    return (_jsxs("div", __assign({ className: 'section' }, { children: [_jsxs("div", __assign({ className: "title ".concat(cssClassMap[props.sportId], " ").concat(cls) }, { children: [_jsxs("div", __assign({ className: 'title__name', onClick: function () { return liveSportClick(props.sportId); } }, { children: [props.sportName, _jsx("span", __assign({ className: 'title__badge title__badge--live' }, { children: "live" }))] })), _jsxs("div", __assign({ className: 'title__rates' }, { children: [_jsx("div", __assign({ className: 'title__rate' }, { children: props.intl.formatMessage(messages.grid_w1) })), !winWithoutDraw.find(function (m) { return m === props.sportId; }) && _jsx("div", __assign({ className: 'title__rate' }, { children: props.intl.formatMessage(messages.grid_x) })), _jsx("div", __assign({ className: 'title__rate' }, { children: props.intl.formatMessage(messages.grid_w2) }))] }))] })), _jsx("div", __assign({ className: 'items' }, { children: props.matches.valueSeq().map(function (match) {
                    var id = match.get('id');
                    var matchProps = {
                        id: id,
                        first: false,
                        section: 'live',
                        gridLocalization: props.gridLocalization
                    };
                    return _jsx(Match, __assign({}, matchProps), id);
                }) }))] })));
};
PopularLiveSports.propTypes = {
    sportName: PropTypes.any.isRequired,
    sportId: PropTypes.number.isRequired,
    matches: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    setDisplayModeAction: PropTypes.func.isRequired
};
export default injectIntl(PopularLiveSports);



// WEBPACK FOOTER //
// ./src/components/grid/popular/PopularLiveSports.jsx